import configureRequest from "./configureRequest";
const sanitizeParams = (params) => {
    let sanitizedBaseUrl = params.baseUrl;
    if (!sanitizedBaseUrl.endsWith("/")) {
        sanitizedBaseUrl += "/";
    }
    const asosWebRequest = configureRequest(params.logger);
    const sanitizedParams = {
        ...params,
        baseUrl: sanitizedBaseUrl,
        asosWebRequest,
    };
    return sanitizedParams;
};
export default sanitizeParams;
